import React, { useContext, useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import AuthContext from "../../contexts/Islogin";

const WithdrawTRX = () => {
  const [toAddress, setToAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { url } = useContext(AuthContext);

  const handleWithdraw = async () => {
    setError(null);
    setResponse(null);
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${url}api/v1/trons/withdraw/usdt`,
        {
          amount: Number(amount),
          toAddress: toAddress,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setResponse(res.data);
    } catch (err) {
      console.error(err);
      if (err.response) {
        setError(err.response.data);
      } else {
        setError({ message: "Something went wrong." });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, width: "60%", mx: "auto", mt: 5 }}>
      <Typography
        variant="h6"
        gutterBottom
        dir="rtl"
        sx={{ textAlign: "right" }}
      >
        برداشت
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="آدرس مقصد (toAddress)"
          variant="outlined"
          value={toAddress}
          onChange={(e) => setToAddress(e.target.value)}
          fullWidth
        />

        <TextField
          label="مقدار (amount)"
          variant="outlined"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          type="number"
          fullWidth
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleWithdraw}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "ارسال برداشت"
          )}
        </Button>

        {/* نمایش پاسخ موفق در جدول */}
        {response?.withdrawal && (
          <Box mt={3}>
            <Typography variant="subtitle1" gutterBottom>
              برداشت ثبت شد:
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">شناسه</TableCell>
                    <TableCell align="center">کاربر</TableCell>
                    <TableCell align="center">آدرس مقصد</TableCell>
                    <TableCell align="center">مقدار</TableCell>
                    <TableCell align="center">وضعیت</TableCell>
                    <TableCell align="center">تاریخ ایجاد</TableCell>
                    <TableCell align="center">TXID</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell align="center">{response.withdrawal.id}</TableCell>
                    <TableCell align="center">{response.withdrawal.user_id}</TableCell>
                    <TableCell align="center">{response.withdrawal.toAddress}</TableCell>
                    <TableCell align="center">{response.withdrawal.amount}</TableCell>
                    <TableCell align="center">{response.withdrawal.status}</TableCell>
                    <TableCell align="center">
                      {new Date(response.withdrawal.created_at).toLocaleString("fa-IR")}
                    </TableCell>
                    <TableCell align="center">
                      {response.withdrawal.TxId || "-"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {/* نمایش خطا */}
        {error && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Alert severity="error">خطا</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default WithdrawTRX;
